import {
  computePosition,
  autoUpdate,
  offset,
  flip,
  shift,
  arrow,
} from "https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.7.3/+esm";

// Check if mobile
function isMobile() {
  return window.innerWidth <= 768;
}

function positionTooltip(dot, tooltip) {
  // Skip floating positioning on mobile
  if (isMobile()) return () => {};

  const preferredPosition = dot.dataset.preferredPosition || "right";
  tooltip.style.position = "absolute";
  tooltip.style.zIndex = "9999";

  const cleanup = autoUpdate(dot, tooltip, () => {
    computePosition(dot, tooltip, {
      strategy: "absolute",
      placement: preferredPosition,
      middleware: [offset(6), shift({ padding: 10 })],
    }).then(({ x, y, placement }) => {
      tooltip.style.left = `${x}px`;
      tooltip.style.top = `${y}px`;

      tooltip.className = tooltip.className.replace(
        /tooltip-positioned-\w+/g,
        "",
      );
      tooltip.classList.add(`tooltip-positioned-${placement.split("-")[0]}`);
    });
  });

  return cleanup;
}

function scrollToProductCard(productId) {
  // Find the mobile product card with matching data-product-id
  const productCard = document.querySelector(
    `[data-product-id="${productId}"].mobile-product-cards`,
  );

  console.log("Looking for productId:", productId);
  console.log("Found mobile product card:", productCard);

  if (productCard) {
    // Scroll the horizontal container to the card
    const scrollContainer =
      productCard.closest(".mobile\\:overflow-x-auto") ||
      productCard.closest('[class*="overflow-x-auto"]');

    if (scrollContainer) {
      const cardLeft = productCard.offsetLeft - scrollContainer.offsetLeft;
      scrollContainer.scrollTo({
        left: cardLeft - 16, // Account for padding
        behavior: "smooth",
      });
    } else {
      // Fallback to scrollIntoView
      productCard.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }

    // Add highlight effect
    productCard.classList.add("ring-2", "ring-blue-500", "ring-opacity-50");
    setTimeout(() => {
      productCard.classList.remove(
        "ring-2",
        "ring-blue-500",
        "ring-opacity-50",
      );
    }, 2000);
  }
}

// Handle mobile hotspot dots (the ones visible only on mobile)
document.querySelectorAll(".hotspot-dot-mobile").forEach((dot) => {
  if (isMobile()) {
    // Get the product ID from the corresponding mobile product card
    // Since mobile dots don't have product IDs, we need to map them by position or index
    const allMobileDots = document.querySelectorAll(".hotspot-dot-mobile");
    const allMobileCards = document.querySelectorAll(".mobile-product-cards");
    const dotIndex = Array.from(allMobileDots).indexOf(dot);

    if (allMobileCards[dotIndex]) {
      const productId = allMobileCards[dotIndex].dataset.productId;

      dot.addEventListener("click", (e) => {
        e.preventDefault();
        scrollToProductCard(productId);
      });
    }
  }
});

// Handle desktop hotspot dots (the ones visible only on desktop)
document.querySelectorAll(".hotspot-dot").forEach((dot) => {
  const tooltip = dot.querySelector("[data-tooltip]");
  const tooltipDisplay = dot.dataset.tooltipDisplay;
  const productId = dot.dataset.productId;

  if (!tooltip) return;

  if (isMobile()) {
    // On mobile, hide tooltips and add click to scroll functionality
    tooltip.style.display = "none";

    dot.addEventListener("click", (e) => {
      e.preventDefault();
      scrollToProductCard(productId);
    });

    dot.style.transform = "translate(-50%, -50%) scale(1.2)";
    return;
  }

  // Desktop behavior
  if (tooltipDisplay === "always") {
    tooltip.style.display = "block";
    positionTooltip(dot, tooltip);
  } else {
    let cleanup = null;

    const show = () => {
      tooltip.style.display = "block";
      cleanup = positionTooltip(dot, tooltip);
    };

    const hide = () => {
      tooltip.style.display = "none";
      if (cleanup) {
        cleanup();
        cleanup = null;
      }
    };

    dot.addEventListener("mouseenter", show);
    dot.addEventListener("mouseleave", hide);
    dot.addEventListener("focus", show);
    dot.addEventListener("blur", hide);
  }
});
